import { Box, Button, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
import React from "react";

interface ConfirmationScreenContentProps {
  handleBackToContent: () => void;
  theme: Theme;
}

const ConfirmationScreenContent: React.FC<ConfirmationScreenContentProps> = ({
  handleBackToContent,
  theme,
}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
          flex: "1 0 0",
          alignSelf: "stretch",
        }}
      >
        {/* Checkmark Frame */}
        <Box
          sx={{
            display: "flex",
            padding: "12px",
            alignItems: "center",
            gap: "8px",
            borderRadius: "5000px",
            border: `1px solid ${theme.palette.Neutral[700]}`,
          }}
        >
          <Box
            sx={{
              width: "60px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
                fill={theme.palette.Neutral[700]}
              />
            </svg>
          </Box>
        </Box>

        {/* Text Frame */}
        <Box
          sx={{
            display: "flex",
            width: "476px",
            flexDirection: "column",
            alignItems: "center",
            gap: "4px",
            borderRadius: "4px",
          }}
        >
          <Typography
            variant="headlineMedium"
            sx={{
              color: theme.palette.Neutral[700],
              textAlign: "center",
            }}
          >
            We let your facilitator know.
          </Typography>
          <Typography
            variant="bodyMedium"
            sx={{
              color: theme.palette.Neutral[500],
              textAlign: "center",
            }}
          >
            They will help you during your next meeting.
          </Typography>
        </Box>
      </Box>

      {/* Bottom Navigation */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          alignSelf: "stretch",
        }}
      >
        <Button
          onClick={(e) => {
            e.stopPropagation();
            handleBackToContent();
          }}
          sx={{
            display: "flex",
            height: "45px",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            borderRadius: "4px",
            background: theme.palette.Learner.Dark.Default,
            padding: "10px 24px",
            minWidth: "auto",
            width: "auto",
            "&:hover": {
              background: theme.palette.Learner.Dark.Pressed,
            },
          }}
        >
          <Typography
            variant="labelMedium"
            sx={{
              color: theme.palette.Neutral[100],
            }}
          >
            Back to Content
          </Typography>
        </Button>
      </Box>
    </>
  );
};

export default ConfirmationScreenContent;
